export * as PlatformBraze from '@braze/web-sdk'

import { deviceIdPromise } from '@/src/common/hooks/useDeviceId/deviceIdPromise'
import { logErrorForUser } from '@/src/common/hooks/useLogError'
import { useUserStore } from '@/src/common/store/useUserStore'
import { appVersion } from '@/src/common/utils/appVersion'
import * as braze from '@braze/web-sdk'
import * as Sentry from '@sentry/react-native'

void (async () => {
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  const userId = useUserStore.getState().userInformation?.id

  braze.initialize(
    (() => {
      const brazeWebApiKey = process.env.EXPO_PUBLIC_BRAZE_WEB_API_KEY
      if (!brazeWebApiKey) {
        logErrorForUser(userId, 'EXPO_PUBLIC_BRAZE_WEB_API_KEY is not set')
        return ''
      }
      return brazeWebApiKey
    })(),
    {
      baseUrl: (() => {
        const brazeWebBaseUrl = process.env.EXPO_PUBLIC_BRAZE_BASE_URL
        if (!brazeWebBaseUrl) {
          logErrorForUser(userId, 'EXPO_PUBLIC_BRAZE_BASE_URL is not set')
          return ''
        }
        return brazeWebBaseUrl
      })(),
      enableLogging: true,
      appVersion,
      appVersionNumber: appVersion,
      enableSdkAuthentication: true,
      deviceId: await deviceIdPromise,
      inAppMessageZIndex: 88888888,
    },
  )

  braze.setLogger((message) => {
    console.log('braze logger', message)
    Sentry.addBreadcrumb({ message })
  })

  braze.openSession()
})()
